import dateformat from "dateformat";
import { Divider } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Controller, useFormContext } from "react-hook-form";
import { useLocation } from "react-router-dom";

import useAuth from "$hooks/useAuth";
import { Text, Timeline } from "$components";
import { DEFAULT_DATE_FORMAT } from "$utils/utils";
import { useStyles } from "../styles/ProfileEDB.styles";
import InformationTable from "../components/InformationTable";
import FileUploader from "$components/FileUploader/FileUploader";
import { useProfileEDBContext } from "../context/ProfileEDBContext";
import { useStyles as useEDBProfileClasses } from "$containers/EDB/styles/EdbProfile.Styles";

export default function InformationsTab() {
  const classes = useStyles();
  const { isAdmin, isClient } = useAuth();
  const { control } = useFormContext();
  const edbClasses = useEDBProfileClasses();

  const { edb, idEdb, opList, tInfoData, isDisabled, edbCompanyCreatedBy } =
    useProfileEDBContext();

  const location = useLocation<{
    breadcrumbs?: Array<{ path: string; name: string }>;
  }>();
  const existingBreadcrumbs = location.state?.breadcrumbs;
  const companyBreadcrumbs = [
    ...(existingBreadcrumbs ?? [
      { path: "/edbs", name: "Liste des expressions de besoin" },
      { path: `/edbs/${idEdb}`, name: edb?.edbId },
    ]),
    {
      path: `/edbs/${idEdb}/entreprise/${edb?.company?._id}`,
      name: edb?.company?.name,
    },
  ];

  const leftTableRows = [
    {
      label: "Nom entreprise",
      value: edb?.company?.name,
      ...(!isClient() && {
        link: `/edbs/${idEdb}/entreprise/${edb?.company._id}`,
        linkState: { breadcrumbs: companyBreadcrumbs },
      }),
    },
    {
      label: "Nom projet",
      value: edb?.project?.name,
      link: `/edbs/${idEdb}/projets/${edb?.project._id}`,
    },
    {
      label: "Code projet",
      value: edb?.project?.code,
    },
    {
      label: "Nom chantier",
      value: edb?.dockyard?.name,
      link: `/edbs/${idEdb}/chantiers/${edb?.dockyard?._id}`,
    },
    {
      label: "Code chantier",
      value: edb?.dockyard?.code,
    },
  ];

  const rightTableRows = [
    {
      label: "Date prévue d'intervention",
      value:
        edb?.scheduledInterventionDate &&
        dateformat(
          new Date(edb.scheduledInterventionDate),
          DEFAULT_DATE_FORMAT
        ),
    },
    {
      label: "Adresse",
      value: (
        <>
          {edb?.dockyard?.address}
          <br />
          {edb?.dockyard?.address2 && (
            <>
              {edb?.dockyard?.address2}
              <br />
            </>
          )}
          {edb?.dockyard?.postalCode} {edb?.dockyard?.city}
          <br />
          {edb?.dockyard?.country}
        </>
      ),
    },
  ];

  const createdByRows = [
    {
      label: "Créée par",
      value: (
        <>
          {edb?.createdBy?.firstname} {edb?.createdBy?.lastname}
          {edbCompanyCreatedBy && (
            <span
              className={
                edbCompanyCreatedBy && !edbCompanyCreatedBy?.isActive
                  ? edbClasses.disabled
                  : "data"
              }
            >
              {` (${edbCompanyCreatedBy?.name})`}
            </span>
          )}
        </>
      ),
      isDisabled: edb?.createdBy?.isDisable,
    },
    ...((edb as any)?.approvedBy
      ? [
          {
            label: "Approuvée par",
            value: `${(edb as any).approvedBy.firstname} ${(
              edb as any
            ).approvedBy.lastname.toUpperCase()}`,
          },
        ]
      : []),
    ...(edb?.approveDesc
      ? [{ label: "Commentaire approbateur", value: edb.approveDesc }]
      : []),
  ];

  return (
    <>
      <div className={classes.timeline}>
        <Timeline
          ops={opList}
          datePrevisionnelle={edb?.scheduledInterventionDate || ""}
          edb={edb || undefined}
          hasProduct={!!(tInfoData || []).length || undefined}
        />
      </div>
      <Divider className={edbClasses.divider} />
      <div className={edbClasses.informations}>
        <div className="about">
          <div className="left">
            <InformationTable rows={leftTableRows} />
          </div>
          <div className="right">
            <InformationTable rows={rightTableRows} />
          </div>
        </div>
      </div>
      <Divider className={edbClasses.divider} />
      <div className={edbClasses.informations}>
        <Text type="h3" className={edbClasses.informationsTitle}>
          Expression de besoin
        </Text>
        <div className="about">
          <div className="left" style={{ border: "none" }}>
            <InformationTable rows={createdByRows} />
          </div>
        </div>
      </div>
      <Divider className={edbClasses.divider} />
      <div className={edbClasses.informations}>
        <div className={classes.attachmentTitle}>
          <AttachFileIcon />
          <Text type="h3" className={edbClasses.informationsTitle}>
            Pièces jointes
          </Text>
        </div>
        <form>
          <Controller
            control={control}
            name="medias"
            render={({ field: { onChange, value } }) => (
              <FileUploader
                value={value}
                onChange={(values) => {
                  onChange(values);
                }}
                isAdmin={isAdmin()}
                type="edb"
                company={(edb?.company as any)?._id}
                id={idEdb}
                isEdit={false}
                isLargeVersion
                isReadOnly={isDisabled}
              />
            )}
          />
        </form>
      </div>
    </>
  );
}
